import Vue from "vue";

export function set_item(state, snaphot) {
  const data = {
    doc_id: snaphot.id,
    ...snaphot.data()
  };

  if (data.path in state.items)
    state.items[data.path] = data;
  else
    Vue.set(state.items, data.path, data);
}

export function set_document(state, snaphot) {
  const data = snaphot.data();
  state.rating_date = data.rating_date;
  state.goal_deadline = data.goal_deadline;
  state.template_ref = data.template;
}

export function set_fetch_timestamp(state) {
  state.lastFetched = +new Date();
}

export function set_document_listener(state, subject) {
  state.document_listener = subject;
}

export function set_items_listener(state, subject) {
  state.items_listener = subject;
}